import { EnvironmentProviders, Provider } from '@angular/core';
import { forceBackToCurrentLocation } from '@bcf-v2-configurators/tokens/cashier/mobile-web-twa/force-back-to-current-location';
import { FORCE_BACK_TO_CURRENT_LOCATION } from '@bcf-v2-configurators/tokens/cashier/token';
import { commonTaxPayoutDetailsInfo } from '@bcf-v2-configurators/tokens/my-bets/letsbetmd/common-tax-payout-details-info';
import { customTaxPayoutDetailsInfo } from '@bcf-v2-configurators/tokens/my-bets/letsbetmd/custom-tax-payout-details-info';
import {
  COMMISSION_ENABLED,
  COMMON_TAX_PAYOUT_DETAIL_INFO,
  CUSTOM_TAX_PAYOUT_DETAIL_INFO,
  EDIT_ENABLED
} from '@bcf-v2-configurators/tokens/my-bets/token';
import { shareBetHost } from '@bcf-v2-configurators/tokens/share-bet/letsbetmd/share-bet-host';
import { SHARE_BET_HOST } from '@bcf-v2-configurators/tokens/share-bet/token';
import { TWA_IN_APP_REVIEW_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/twa-in-app-review/tokens';
import { USE_US_SPORT_ICONS } from '@bcf-v2-configurators/tokens/us-sport-icons/token';

export const settingsProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: FORCE_BACK_TO_CURRENT_LOCATION,
    useValue: forceBackToCurrentLocation
  },
  {
    provide: COMMISSION_ENABLED,
    useValue: false
  },
  {
    provide: COMMON_TAX_PAYOUT_DETAIL_INFO,
    useValue: commonTaxPayoutDetailsInfo
  },
  {
    provide: CUSTOM_TAX_PAYOUT_DETAIL_INFO,
    useValue: customTaxPayoutDetailsInfo
  },
  {
    provide: SHARE_BET_HOST,
    useValue: shareBetHost
  },
  {
    provide: USE_US_SPORT_ICONS,
    useValue: true
  },
  {
    provide: TWA_IN_APP_REVIEW_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/twa-in-app-review/letsbetmd/mobile-web-twa/twa-in-app-review-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.twaInAppReviewConfig
      )
  },
  {
    provide: EDIT_ENABLED,
    useValue: false
  }
];
